// A timeslot without `courts` applies to all settings.available_courts.
// invispots checks `!ts.courts || ts.courts.includes(court)`, so an empty
// array would hide the slot for every court: drop it before saving.
export const stripEmptyTimeslotCourts = (values) => {
  if (!Array.isArray(values.timeslots)) return values
  return {
    ...values,
    timeslots: values.timeslots.map((slot) => {
      if (!slot || (Array.isArray(slot.courts) && slot.courts.length)) {
        return slot
      }
      const { courts, ...rest } = slot
      return rest
    }),
  }
}

const isNumeric = (court) => /^\d+$/.test(String(court))

// Label for one court: numeric ids get the location's court_title ('Baan 5').
export const courtLabel = (court, courtTitle) =>
  courtTitle && isNumeric(court) ? `${courtTitle} ${court}` : String(court)

// [5, 6] + 'Baan' -> 'baan 5, 6'; ['baan 5', 'baan 6'] -> 'baan 5, 6';
// mixed names are joined as-is.
export const formatCourts = (courts, courtTitle) => {
  if (courtTitle && courts.every(isNumeric)) {
    return `${courtTitle.toLowerCase()} ${courts.join(', ')}`
  }
  const parts = courts.map((court) => /^(.*\D)\s*(\d+)$/.exec(String(court)))
  const prefix = parts[0] && parts[0][1].trim()
  if (parts.every((p) => p && p[1].trim() === prefix)) {
    return `${prefix} ${parts.map((p) => p[2]).join(', ')}`
  }
  return courts.join(', ')
}
